import { Box } from '@mui/material';

import { useSiteConfigContext } from '../contexts/SiteConfigContext'; // ADDED

const APP_BAR_HEIGHT = 64;

export default function AppBarSpacer() {
    const siteConfig = useSiteConfigContext();

    const calcSize = () => {
        if (!siteConfig) {
            return APP_BAR_HEIGHT + 14;
        }

        const bannerSize = siteConfig.siteBanner ? 36 : 0;
        const descSize = siteConfig.siteDescription ? 24 : 0;

        return APP_BAR_HEIGHT + 24 + bannerSize + descSize;
    };

    // CHANGED — smaller spacer on mobile
    return <Box sx={{ height: { xs: `${calcSize() * 0.7}px`, md: `${calcSize()}px` }, flexShrink: 0 }} />;
}
